import { render, staticRenderFns } from "./InternetOfferDetails.vue?vue&type=template&id=31ae0360&"
import script from "./InternetOfferDetails.vue?vue&type=script&lang=ts&"
export * from "./InternetOfferDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37545539/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31ae0360')) {
      api.createRecord('31ae0360', component.options)
    } else {
      api.reload('31ae0360', component.options)
    }
    module.hot.accept("./InternetOfferDetails.vue?vue&type=template&id=31ae0360&", function () {
      api.rerender('31ae0360', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/orange/broadband/internet/showcase/components/InternetOfferDetails.vue"
export default component.exports